import { render, staticRenderFns } from "./SectionFooter.vue?vue&type=template&id=591fd6b2&scoped=true&"
import script from "./SectionFooter.vue?vue&type=script&lang=js&"
export * from "./SectionFooter.vue?vue&type=script&lang=js&"
import style0 from "./SectionFooter.vue?vue&type=style&index=0&id=591fd6b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591fd6b2",
  null
  
)

export default component.exports